/*-----------------------------------------------------------------
- Forms translations
-----------------------------------------------------------------*/
export default {

    select: {
        label: {
            group: {
                select  : '',
                deselect: '',
            },
            single: {
                select  : '',
                deselect: '',
            },
            selected: '',
        },
        placeholder: {
            default: 'اختر من بين الخيارات.',
            tag    : '',
            search : 'بحث...',
        },
        message: {
            no_options:'لا يوجد خيار.',
            no_search : 'بحث لعرض الخيارات',
            no_result : 'لم يتم العثور على نتائج.',
        },
    },

};
